import { atom } from "recoil";
import { ITerm } from "shared/types/accounting";
import { IGlCode } from "shared/types/dbRecords";
import { IProductCode } from '@shared/types/accounting';


export const productCodesAtom = atom<IProductCode[]>({
  key: 'productCodesAtom',
  default: [],
});
export const glCodesAtom = atom<IGlCode[]>({
  key: 'glCodesAtom',
  default: [],
});
export const termsAtom = atom<ITerm[]>({
  key: 'termsAtom',
  default: [],
});

